import styled from '@emotion/styled'
import { visuallyhidden } from '../../__styling/style-mixins'
import { breakpoint } from '../../__styling/style-functions'
import { calcRem } from '../../__styling/style-functions/calc-rem'

export const StyledRegionalContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: calcRem(theme.margins.sm, theme.margins.md),

    '.text-weare': {
        width: calcRem(80),
        height: calcRem(15),
    },

    '.text-regional': {
        width: calcRem(132),
        height: calcRem(33),
    },

    [breakpoint('sm')]: {
        flexDirection: ['row', 'unset'],
        padding: calcRem(theme.margins.md),

        '.text-weare': {
            width: calcRem(112),
            height: calcRem(21),
            marginRight: calcRem(4),
            marginBottom: calcRem(16),
        },

        '.text-regional': {
            width: calcRem(184),
            height: calcRem(45),
        },
    },
}))

export const StyledTitle = styled('span')(visuallyhidden)
